<template>
    <div>
            <v-row row wrap>
                <v-col xs12 md12>
                    <div>
                        <div class="headline" v-if="id === undefined">Grüne Karte erfassen</div>
                        <div class="headline" v-else>Auftrag bearbeiten</div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-card class="mb-4">
                        <v-card-title primary-title class="title">Kundendaten</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="4" lg="6">
                                    <v-radio-group v-model="duty.gender" label="Anrede" row>
                                        <v-radio label="Frau" value="female"></v-radio>
                                        <v-radio label="Herr" value="male"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="6" offset="2" lg="6" offset-lg="0" class="d-flex align-center justify-end">
                                    <v-btn class="mr-1" v-on:click="dialogCompany = !dialogCompany" small>Unternehmen</v-btn>
                                    <v-btn v-on:click="dialog = !dialog" small>Straße suchen</v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field label="Vorname" v-model="duty.firstname"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Nachname" v-model="duty.lastname"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-autocomplete
                                    :items="districts"
                                    item-text="cityAndDistrict"
                                    item-value="id"
                                    v-model="duty.district"
                                    label="Gemeinde"
                                    no-data-text="Keine Gemeinde vorhanden"
                            >
                                <template slot="item" slot-scope="data">
                                    {{ data.item.cityAndDistrict }}
                                </template>
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.cityAndDistrict }}
                                </template>
                            </v-autocomplete>
                            <v-row>
                                <v-col cols="8">
                                    <v-autocomplete
                                            :items="possibleStreets"
                                            item-text="name"
                                            item-value="id"
                                            v-model="duty.street"
                                            label="Straße"
                                            no-data-text="Keine Straße vorhanden"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Hausnummer" v-model="duty.streetNumber"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field label="E-Mail" v-model="duty.email"></v-text-field>
                            <v-text-field label="Telefon" v-model="duty.phone"></v-text-field>
                            <v-textarea label="Kommentar" v-model="duty.comment"></v-textarea>
                            <v-textarea label="Kommentar an den Kunden" v-model="duty.commentCustomer"></v-textarea>
                            <v-switch label="Warteliste" v-model="duty.waitingList" color="primary"></v-switch>
                            <!--<v-btn small v-if="duty.id === 0">Unternehmen auswählen</v-btn>-->
                        </v-card-text>
                    </v-card>
                    <v-card v-if="duty.district > 0">
                        <v-card-title primary-title class="title">Tour</v-card-title>
                        <v-card-text>
                            <v-select
                                    :items="possibleTour"
                                    item-text="tour"
                                    item-value="id"
                                    v-model="duty.tour"
                                    label="Tour"
                                    no-data-text="Keine Tour vorhanden"
                            >
                                <template slot="selection" slot-scope="data">
                                  <v-row style="width: 100%">
                                    <v-col cols="1"><TourID :tour="data.item"></TourID></v-col>
                                    <v-col cols="2" class="align-self-center">{{ data.item.date }}</v-col>
                                    <v-col cols="7" class="align-self-center">{{ data.item.name }}</v-col>
                                    <v-col cols="2"><TourWorkload :tour="data.item"></TourWorkload></v-col>
                                  </v-row>
                                </template>
                                <template slot="item" slot-scope="data">
                                  <v-row style="width: 100%">
                                    <v-col cols="1"><TourID :tour="data.item"></TourID></v-col>
                                    <v-col cols="2" class="align-self-center">{{ data.item.date }}</v-col>
                                    <v-col cols="7" class="align-self-center">{{ data.item.name }}</v-col>
                                    <v-col cols="2"><TourWorkload :tour="data.item"></TourWorkload></v-col>
                                  </v-row>
                                </template>
                            </v-select>
                            <v-btn v-if="checkAccess(['ROLE_USER'])" small v-on:click="showTour = 'all'">Alle Touren einblenden</v-btn>
                            <!--<v-btn v-if="checkAccess(['ROLE_USER', 'ROLE_RESTRICTED'])" small v-on:click="showTour = 'mt'">Möbeltouren einblenden</v-btn>-->
                            <v-btn v-if="checkAccess(['ROLE_USER'])" small v-on:click="showTour = 'mt'">Möbeltouren einblenden</v-btn>
                            <v-btn v-if="checkAccess(['ROLE_USER', 'ROLE_RESTRICTED'])" small @click="deleteTour()" color="error">Datum löschen</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col xs12 sm12 md6 lg6 xl6>
                    <v-card class="mb-4">
                        <v-card-title primary-title class="title">Artikel</v-card-title>
                        <v-card-text>
                            <v-alert v-model="hasDevices" type="error">
                                Es muss mindestens ein Artikel eingetragen werden.
                            </v-alert>
                            <v-row>
                                <template v-for="field in devices">
                                    <v-col cols="4" :key="field.id">
                                        <v-text-field
                                          type="number"
                                          :label="field.name.split('&nbsp;').join(' ')"
                                          :value="getDevicesFromField(duty.devices, field.id)"
                                          v-on:input="setDeviceAmount(field.id, $event)">
                                        </v-text-field>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-title primary-title class="title">Log</v-card-title>
                        <v-card-text>
                            <v-list two-line>
                                <template v-for="(item, index) in duty.log">
                                    <v-list-item :key="index">
                                        <v-list-item-action>
                                            <v-icon v-if="item.status === 'created'">far fa-plus-circle</v-icon>
                                            <v-icon v-else-if="item.status === 'tour'">far fa-clipboard-list</v-icon>
                                            <v-icon v-else-if="item.status === 'email'">far fa-envelope</v-icon>
                                            <v-icon v-else-if="item.status === 'delete'">far fa-trash</v-icon>
                                            <v-icon v-else-if="item.status === 'error'">far fa-exclamation-triangle</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.date }} Uhr - {{ item.user }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn v-on:click="save()" color="primary">Speichern</v-btn>
                <v-btn v-on:click="sendEmail()" color="primary" v-if="duty.tour > 0 && duty.email !== ''">E-Mail versenden</v-btn>
                <v-btn color="green" :to="{name: 'duty_new'}" v-if="id !== undefined">Grüne Karte erfassen</v-btn>
                <v-btn v-on:click="nextNewDuty()" color="" v-if="id !== undefined">Nächsten Auftrag bearbeiten</v-btn>
                <v-btn v-on:click="deleteEntry()" color="warning" v-if="checkAccess(['ROLE_USER']) && id !== undefined">Löschen</v-btn>
              </v-col>
            </v-row>
        <v-snackbar v-model="snackbar">
            <span>{{ snackbarText }}</span>
            <v-btn color="primary " text @click="snackbar = false">Schließen</v-btn>
        </v-snackbar>
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Straße suchen</span>
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                            :items="streets"
                            item-text="name"
                            item-value="id"
                            v-model="street"
                            :filter="streetFilter"
                            label="Straße"
                            no-data-text="Keine Straße vorhanden"
                    >
                        <template slot="item" slot-scope="data">
                            {{ getCity(data.item.city).name }} - {{ getDistrict(data.item.district).name }} - {{ data.item.name }}
                        </template>
                        <template slot="selection" slot-scope="data">
                          {{ getCity(data.item.city).name }} - {{ getDistrict(data.item.district).name }} - {{ data.item.name }}
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="dialog = false">Abbrechen</v-btn>
                    <v-btn text color="primary" @click.native="chooseStreet()">Übernehmen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCompany" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Unternehmen suchen</span>
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                            :items="companies"
                            item-text="name"
                            item-value="id"
                            v-model="company"
                            :filter="companyFilter"
                            label="Unternehmen"
                            no-data-text="Kein Unternehmen vorhanden vorhanden"
                    >
                        <template slot="item" slot-scope="data">
                            {{ data.item.cityName }} - {{ data.item.districtName }} - {{ data.item.name }}
                        </template>
                        <template slot="selection" slot-scope="data">
                            {{ data.item.cityName }} - {{ data.item.districtName }} - {{ data.item.name }}
                        </template>
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="dialogCompany = false">Abbrechen</v-btn>
                    <v-btn text color="primary" @click.native="chooseCompany()">Übernehmen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import dutyService from '../service/dutyService'
import TourName from './TourName'
import TourWorkload from './TourWorkload'
import TourID from './TourID'

export default {
  name: 'Duty',
  components: {TourID, TourWorkload, TourName},
  props: ['id'],
  data: () => ({
    dialog: false,
    dialogCompany: false,
    street: '',
    company: '',
    snackbar: false,
    snackbarText: '',
    showTour: '',
    duty: {},
    dutyOrg: {},
    defaultDuty: {
      id: 0,
      gender: '',
      firstname: '',
      lastname: '',
      deleted: false,
      waitingList: false,
      email: '',
      phone: '',
      street: 0,
      district: 0,
      streetNumber: '',
      tour: 0,
      devices: [],
      log: [],
      comment: '',
      commentCustomer: ''
    }
  }),
  computed: {
    possibleTour () {
      if (this.showTour === '') {
        let tour = null
        if (this.id === undefined || this.duty.tour === 0) {
          let now = new Date()
          tour = this.tour.filter(element => {
            let tourDate = new Date(element.dateEn)
            if (element.districts.includes(this.duty.district) && tourDate > now) {
              return element
            }
          })
        } else {
          tour = this.tour.filter(element => element.districts.includes(this.duty.district))
        }

        if (undefined === tour) {
          return [{
            tour: 0,
            cities: []
          }]
        }
        return tour
      } else if (this.showTour === 'mt') {
        let now = new Date()
        let tour = this.tour.filter(element => {
          let tourDate = new Date(element.dateEn)
          if (element.identifier === 'MT' && tourDate > now) {
            return element
          }
        })

        if (undefined === tour) {
          return [{
            tour: 0,
            cities: []
          }]
        }
        return tour
      }

      return this.tour
    },
    tour () {
      return this.$store.state.tour.all
    },
    cities () {
      return this.$store.state.cities.all
    },
    districts () {
      return this.$store.state.districts.all
    },
    devices () {
      return this.$store.state.devices.all
    },
    duties () {
      return this.$store.state.duties.all
    },
    streets () {
      return this.$store.state.streets.all
    },
    companies () {
      return this.$store.state.companies.all
    },
    possibleStreets () {
      const district = parseInt(this.duty.district)
      if (this.duty !== undefined && district > 0) {
        return this.$store.state.streets.all.filter(item => item.district === district)
      }
      return []
    },
    hasDevices () {
      let counter = 0
      for (let device in this.duty.devices) {
        if (this.duty.devices[device] > 0) {
          counter++
        }
      }
      return counter === 0
    },
    profile () {
      if (this.$store.getters.getProfile.data !== undefined) {
        return this.$store.getters.getProfile.data
      }
      return {firstname: '', lastname: '', roles: []}
    }
  },
  created () {
    this.fetchData()
  },
  beforeRouteLeave (to, from, next) {
    this.checkUpdate(next)
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData',
    duties: function () {
      /*
      let duty = this.duties.find(element => element.id === this.id)
      if (undefined !== duty) {
        this.duty = duty
        this.dutyOrg = Object.assign({}, duty)
      }
      */
    }
  },
  methods: {
    getCityFromStreetId (streetId) {
      const street = this.getStreet(streetId)
      if (street !== undefined) {
        const city = this.getCity(street.city)
        if (city !== undefined) {
          return city
        }
      }
      return {
        name: ''
      }
    },
    getDistrictFromStreetId (streetId) {
      const street = this.getStreet(streetId)
      if (street !== undefined) {
        const district = this.getDistrict(street.district)
        if (district !== undefined) {
          return district
        }
      }
      return {
        name: ''
      }
    },
    checkUpdate (next) {
      let entry = this.duty
      if (entry !== undefined) {
        if (JSON.stringify(entry) !== JSON.stringify(this.dutyOrg)) {
          const answer = confirm('Sie haben Änderungen vorgenommen aber bisher nicht gespeichert. Wollen Sie diese verwerfen?')
          if (answer) {
            next()
          } else {
            next(false)
          }
        } else {
          next()
        }
      } else {
        next()
      }
    },
    fetchData () {
      if (this.$route.params.id !== undefined) {
        dutyService.getDuty(this.$route.params.id).then(data => {
          this.duty = data
          this.dutyOrg = Object.assign({}, data)
        },
        reason => {
          this.duty = JSON.parse(JSON.stringify(this.defaultDuty))
        })
      } else {
        this.duty = JSON.parse(JSON.stringify(this.defaultDuty))
      }
    },
    sendEmail () {
      dutyService.sendMail(this.duty.id).then(
        data => {
          this.snackbarText = 'E-Mail an Kunden wurde versandt'
          this.snackbar = true
          this.fetchData()
        },
        reason => {
          this.snackbarText = 'E-Mail an Kunden konnte nicht versandt'
          this.snackbar = true
        }
      )
    },
    save () {
      this.duty.id = this.id
      this.dutyOrg = Object.assign({}, this.duty)
      if (this.id > 0) {
        dutyService.updateDuty(this.duty).then(
          data => {
            this.duty = data
            this.dutyOrg = Object.assign({}, this.duty)
            this.$store.commit('updateDutyInState', this.duty)
            this.$store.commit('getAllDuties')
            this.$store.commit('getAllTour')
          }
        )
      } else {
        dutyService.addDuty(this.duty).then(
          data => {
            this.duty = data
            this.dutyOrg = Object.assign({}, this.duty)
            this.$router.push({name: 'duty', params: {id: data.id}})
          }
        )
      }

      this.showTour = ''
      this.snackbarText = 'Daten wurden gespeichert'
      this.snackbar = true
    },
    deleteEntry () {
      this.snackbarText = 'Datensatz wurde gelöscht'
      this.snackbar = true
      this.duty.deleted = true
      this.duty.id = this.id
      if (this.id > 0) {
        this.$store.commit('deleteDuty', this.duty)
      }
      this.$router.push('/duties')
    },
    deleteTour () {
      this.duty.tour = null
      this.save()
    },
    nextNewDuty () {
      const duty = this.duties.find(item => item.tour === 0 && item.waitingList !== true && item.deleted !== true)
      if (duty !== undefined) {
        window.scrollTo(0, 0)
        this.$router.push({name: 'duty', params: {id: duty.id}})
      }
    },
    getCity (id) {
      return this.cities.find(element => element.id === id)
    },
    getDistrict (id) {
      return this.districts.find(element => element.id === id)
    },
    getStreet (id) {
      return this.streets.find(element => element.id === id)
    },
    getCompany (id) {
      return this.companies.find(element => element.id === id)
    },
    getTour (id) {
      return this.tour.filter(element => element.id === id)
    },
    chooseStreet () {
      this.duty.district = this.getStreet(this.street).district
      this.duty.street = this.street
      this.street = ''
      this.dialog = false
    },
    chooseCompany () {
      let company = this.getCompany(this.company)
      this.duty.lastname = company.name
      this.duty.district = parseInt(company.district)
      this.duty.street = parseInt(company.street)
      this.duty.streetNumber = company.streetNumber
      this.duty.comment = company.comment
      this.company = ''
      this.dialogCompany = false
    },
    streetFilter (item, queryText, itemText) {
      const cityName = this.getCity(item.city).name
      const districtName = this.getDistrict(item.district).name
      return cityName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
        districtName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
        item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },
    companyFilter (item, queryText, itemText) {
      return item.cityName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
        item.districtName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
        item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },
    checkAccess (roles) {
      return roles.some(r => this.profile.roles.includes(r))
    },
    setDeviceAmount (fieldId, event) {
      if (this.duty.devices[fieldId] === undefined) {
        Vue.set(this.duty.devices, fieldId, event)
      } else {
        this.duty.devices[fieldId] = event
      }
    },
    getDevicesFromField (devices, fieldId) {
      if (devices !== undefined) {
        return devices[fieldId]
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/Duty.vue